<template>

<com-list api="account/profile/offers" route="Account/Profile/Offers" :text="text" v-on:update="items = arguments[0]" v-on:create="onCreate">

	<com-item :text="text" v-for="item in items" :key="item.id" :item="item" v-on:edit="onEdit" v-on:delete="onDelete" v-on:up="onUp" v-on:down="onDown" />

</com-list>

</template>

<script>

import comList from './../common/List'
import comItem from './offers/Item'

import mixList from '@/mixin/list.js'

export default {

    mixins: [mixList],

    components: {
        'com-list': comList,
        'com-item': comItem
    },

    data: function() {

        return {
            lang: 'business_profile_offer',
            list: 'account/profile/offers'
        }

    }

}

</script>